import React from 'react';
import { DevicesConsumptionProps } from '../../../../components/ComposableDevice/Dashboard/ConsumptionForm';
import { getPolyglot } from '../../../../i18n';
import { Divider, InputAdornment, TextField, Typography } from '@mui/material';
import {
  ST_COMPOSABLE_CONSUMPTION_DATA_KEY,
  ST_KILO_WATT_EUR_CONSUMPTION_KEY,
} from '../../../../redux/composableDevice/ComposableDevice.model';
import _ from 'lodash';

export const ConsumptionDetailsFROvenForm = (
  props: DevicesConsumptionProps
) => {
  const { formik, group } = props;

  const groupId = group?.id || '';
  const priceValue =
    group?.composableDevice?.labels?.ST_KILO_WATT_EUR_CONSUMPTION_KEY ||
    formik.values[ST_KILO_WATT_EUR_CONSUMPTION_KEY] ||
    0;
  const consumptionValue =
    group?.composableDevice?.labels?.consumption ||
    formik.values[ST_COMPOSABLE_CONSUMPTION_DATA_KEY][groupId] ||
    0;
  const polyglot = getPolyglot();

  return (
    <>
      <TextField
        key={`${ST_COMPOSABLE_CONSUMPTION_DATA_KEY}.${groupId}`}
        name={`${ST_COMPOSABLE_CONSUMPTION_DATA_KEY}.${groupId}`}
        type="number"
        label={group?.name?.concat(
          ` ${polyglot.t('composable_device.dashboard_consumption_setting')}`
        )}
        onChange={formik.handleChange}
        value={consumptionValue}
        required
        error={
          formik.touched[ST_COMPOSABLE_CONSUMPTION_DATA_KEY]?.[groupId] &&
          Boolean(formik.errors[ST_COMPOSABLE_CONSUMPTION_DATA_KEY]?.[groupId])
        }
        helperText={polyglot.t('fours_fringand.oven.consumptionHelperText')}
        InputProps={{
          endAdornment: <InputAdornment position="end">Kw</InputAdornment>,
        }}
      />
      <Typography variant="body2" display="block" gutterBottom>
        {}
      </Typography>
      <Divider />
      <TextField
        key={ST_KILO_WATT_EUR_CONSUMPTION_KEY}
        name={ST_KILO_WATT_EUR_CONSUMPTION_KEY}
        type="number"
        label={polyglot.t(
          'composable_device.dashboard_consumption_setting_kwh_price'
        )}
        onChange={formik.handleChange}
        value={priceValue}
        required
        error={
          formik.touched[ST_KILO_WATT_EUR_CONSUMPTION_KEY] &&
          Boolean(formik.errors[ST_KILO_WATT_EUR_CONSUMPTION_KEY])
        }
        helperText={polyglot.t('fours_fringand.oven.pricePerKwhHelperText')}
        InputProps={{
          endAdornment: <InputAdornment position="end">€</InputAdornment>,
        }}
      />
    </>
  );
};
